/**
 * Formats a number with three-digit separators for Persian/Farsi display
 * @param {number|string} number - The number to format
 * @returns {string} - Formatted number with Persian separators
 */
export const formatNumberWithSeparators = (number) => {
  if (!number && number !== 0) return '';
  
  // Convert to string and remove any existing separators
  const numStr = String(number).replace(/[^\d]/g, '');
  
  if (!numStr) return '';
  
  // Add three-digit separators from right to left
  const formatted = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  return formatted;
};

/**
 * Formats a number with Persian three-digit separators (using Persian comma)
 * @param {number|string} number - The number to format
 * @returns {string} - Formatted number with Persian separators
 */
export const formatNumberWithPersianSeparators = (number) => {
  if (!number && number !== 0) return '';
  
  // Convert to string and remove any existing separators
  const numStr = String(number).replace(/[^\d]/g, '');
  
  if (!numStr) return '';
  
  // Add three-digit separators from right to left using Persian comma
  const formatted = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, '،');
  
  return formatted;
};


